module.exports = __webpack_public_path__ + "assets/normal/images/Empty_7.817ff3bb.png";